/**
 * Application Configuration
 * Centralized configuration for the BioMercy application
 */

const config = {
  app: {
    name: process.env.REACT_APP_NAME || 'BioMercy',
    version: process.env.REACT_APP_VERSION || '1.0.0',
  },
  api: {
    baseURL: process.env.REACT_APP_API_URL || '',
    version: process.env.REACT_APP_API_VERSION || 'v1',
    timeout: 30000,
  },
  features: {
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    debug: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  },
  contact: {
    email: process.env.REACT_APP_CONTACT_EMAIL || 'contacto@biomercy.com',
  },
};

export default config;
